import { render, staticRenderFns } from "./Submission.vue?vue&type=template&id=cb60d8e0&scoped=true&"
import script from "./Submission.vue?vue&type=script&lang=ts&"
export * from "./Submission.vue?vue&type=script&lang=ts&"
import style0 from "./Submission.vue?vue&type=style&index=0&id=cb60d8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb60d8e0",
  null
  
)

export default component.exports